import React from 'react'
import { red_info } from '../../../assets/images'

const Input = ({ type = 'text', name = '', label = '', value = '', disable = false, inputClasses='', error = '', placeholder = '', blurHandler, handler, labelClasses = '', classes = '', subLabel = '', subLabelClasses = '', ...rest }) => {
  labelClasses = labelClasses || 'text-2xs uppercase tracking-widest text-gray-600 font-semibold'
  return (
    <div className={classes}>
      {label && <span className={'block mb-2 '+ labelClasses}>{label}</span>}
      {subLabel && <span className={'block mb-2 '+ subLabelClasses}>{subLabel}</span>}
      <input type={type} name={name} disabled={disable} value={value} placeholder={placeholder} onBlur={blurHandler} onChange={handler} className={`w-full rounded-ds-sm border border-gray-275 bg-white px-3 py-2.5 text-xs font-normal text-gray-900 placeholder-gray-500 transition-shadow focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900 disabled:bg-gray-100 disabled:text-gray-500 ${inputClasses}`} {...rest}/>
      {error && <span className='text-ds-rose text-xs flex flex-row mt-2'><img src={red_info} style={{marginRight : '5px'}}></img>{error}</span> }
    </div>
  )
}

export default Input
